var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.groups)?_c('div',_vm._l((_vm.groups),function(lv,index){return _c('div',{key:lv.key,ref:`item-${index}`,refInFor:true},[_c('Level',{attrs:{"level":lv},on:{"click":(item) => {
        _vm.s2Click(item, lv, index);
        ;
      }}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }